export default __webpack_public_path__ + "static/media/ale_munoz.bd7f55fd.png";